import { render, staticRenderFns } from "./rgTemplateAnnouncement.vue?vue&type=template&id=8072b0be&"
import script from "./rgTemplateAnnouncement.vue?vue&type=script&lang=ts&"
export * from "./rgTemplateAnnouncement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports